import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TEmManagementStore,
	TEmManagementListResponsePayload,
	TEmManagementByIdResponsePayload,
	TEmManagementByIdFullResponsePayload,
	TAdditionalServicesResponsePayload,
	TEmAdditionalServicesResponsePayload,
	TEmCommentsResponsePayload,
	TEmCommentGetByIdResponsePayload,
	TEmSitesListResponsePayload,
	TEmInvoiceListResponsePayload,
	TEmPaymentMethodsResponsePayload,
} from './types';

export const getEmManagementState = (state: TStoreState): TEmManagementStore => state.emManagement;

export const getEmManagementList = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emManagementList,
);

// ==========================================:

export const getEmManagementListData = createSelector(
	[getEmManagementList],
	(emManagementList: TEmManagementListResponsePayload) => emManagementList,
);

// ==========================================:

export const getEmManagementListLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emManagementListLoading,
);

// ==========================================:

export const getEmById = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emById,
);

// ==========================================:

export const getEmByIdData = createSelector(
	[getEmById],
	(emById: TEmManagementByIdResponsePayload) => emById,
);

// ==========================================:

export const getEmByIdLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emByIdLoading,
);

// ==========================================:

export const getEmByIdFull = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emByIdFull,
);

export const getEmByIdFullData = createSelector(
	[getEmByIdFull],
	(emByIdFull: TEmManagementByIdFullResponsePayload) => emByIdFull,
);

export const getEmByIdFullLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emByIdFullLoading,
);

export const getEmByIdFullError = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emByIdFullError,
);
// ==========================================:

export const getUpdateEmLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.updateEmLoading,
);

// ==========================================:

export const getUpdateEmSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.updateEmSuccess,
);

// ==========================================:

export const getUpdateEmerchantLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.updateEmerchantLoading,
);

export const getUpdateEmerchantWarning = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.updateEmerchantSuccess,
);

export const getUnblockEmerchantLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.unblockEmerchantLoading,
);

export const getUnblockEmerchantSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.unblockEmerchantSuccess,
);

export const getBlockEmerchantLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.blockEmerchantLoading,
);

export const getBlockEmerchantSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.blockEmerchantSuccess,
);

export const getActivateEmerchantLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.activateEmerchantLoading,
);

export const getActivateEmerchantSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.activateEmerchantSuccess,
);

export const getDuplicateEmerchantLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.duplicateEmerchantLoading,
);

export const getDuplicateEmerchantSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.duplicateEmerchantSuccess,
);

export const getActivateEuDdpLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.activateEuDdpLoading,
);

export const getActivateEuDdpSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.activateEuDdpSuccess,
);

// ==========================================:

export const getAdditionalServices = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.additionalServices,
);

export const getAdditionalServicesData = createSelector(
	[getAdditionalServices],
	(additionalServices: TAdditionalServicesResponsePayload) => additionalServices,
);

export const getAdditionalServicesLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.additionalServicesLoading,
);

// ==========================================:

export const getCreateAdditionalServiceLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.createAdditionalServiceLoading,
);

export const getCreateAdditionalServiceSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.createAdditionalServiceSuccess,
);

export const getUpdateAdditionalServiceLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.updateAdditionalServiceLoading,
);

export const getUpdateAdditionalServiceSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.updateAdditionalServiceSuccess,
);

// ==========================================:

export const getEmAdditionalServices = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emAdditionalServices,
);

export const getEmAdditionalServicesData = createSelector(
	[getEmAdditionalServices],
	(emAdditionalServices: TEmAdditionalServicesResponsePayload) => emAdditionalServices,
);

export const getEmAdditionalServicesLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emAdditionalServicesLoading,
);

export const getCreateEmAdditionalServiceLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.createEmAdditionalServiceLoading,
);

export const getCreateEmAdditionalServiceSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.createEmAdditionalServiceSuccess,
);

export const getUpdateEmAdditionalServiceLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.updateEmAdditionalServiceLoading,
);

export const getUpdateEmAdditionalServiceSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.updateEmAdditionalServiceSuccess,
);

// ==========================================:

export const getEmAdditionalServiceInvoiceLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emAdditionalServiceInvoiceLoading,
);

export const getEmAdditionalServiceInvoiceSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emAdditionalServiceInvoiceSuccess,
);

// ==========================================:

export const getEmInvoicePdfLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emInvoicePdfLoading,
);

export const getEmInvoicePdfSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emInvoicePdfSuccess,
);

// ==========================================:

export const getEmAdditionalServiceCancelLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emAdditionalServiceCancelLoading,
);

export const getEmAdditionalServiceCancelSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emAdditionalServiceCancelSuccess,
);

// ==========================================:

export const getSpecialRegistrations = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.specialRegistrations,
);

// ==========================================:

export const getSpecialRegistrationsLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.specialRegistrationsLoading,
);

// ==========================================:

export const getDeleteScheduleTerminationLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.deleteScheduleTerminationLoading,
);

export const getDeleteScheduleTerminationSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.deleteScheduleTerminationSuccess,
);

// ==========================================:

export const getEnumsFeeClass = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsFeeClass,
);

export const getEnumsFeeClassLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsFeeClassLoading,
);

export const getEnumsAnnualFeeTypeId = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsAnnualFeeTypeId,
);

export const getEnumsAnnualFeeTypeIdLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsAnnualFeeTypeIdLoading,
);

export const getEnumsInvoiceFeeTypeId = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsInvoiceFeeTypeId,
);

export const getEnumsInvoiceFeeTypeIdLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsInvoiceFeeTypeIdLoading,
);

export const getMonthlyFees = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.monthlyFees,
);

export const getMonthlyFeesLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.monthlyFeesLoading,
);

export const getFeeClasses = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.feeClasses,
);

export const getFeeClassesLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.feeClassesLoading,
);

export const getEnumsTimezoneList = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsTimezoneList,
);

export const getEnumsTimezoneListLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsTimezoneListLoading,
);

// Additional enums selectors
export const getEnumsWeightUnit = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsWeightUnit,
);

export const getEnumsWeightUnitLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsWeightUnitLoading,
);

export const getEnumsCustomsDataStatus = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsCustomsDataStatus,
);

export const getEnumsCustomsDataStatusLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsCustomsDataStatusLoading,
);

export const getEnumsPaymentMode = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsPaymentMode,
);

export const getEnumsPaymentModeLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsPaymentModeLoading,
);

export const getEnumsIossSaleOverThresholdOption = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsIossSaleOverThresholdOption,
);

export const getEnumsIossDutyMode = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsIossDutyMode,
);

export const getEnumsIossDutyModeLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsIossDutyModeLoading,
);

export const getEnumsIossSaleOverThresholdOptionLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsIossSaleOverThresholdOptionLoading,
);

export const getEnumsSupportedCurrency = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsSupportedCurrency,
);

export const getEnumsSupportedCurrencyLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsSupportedCurrencyLoading,
);

export const getEnumsCurrencyCode = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsCurrencyCode,
);

export const getEnumsCurrencyCodeLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsCurrencyCodeLoading,
);

export const getEnumsReportingFeeActual = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsReportingFeeActual,
);

export const getEnumsReportingFeeActualLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsReportingFeeActualLoading,
);

export const getEnumsSiteIntegrationType = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsSiteIntegrationType,
);

export const getEnumsSiteIntegrationTypeLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsSiteIntegrationTypeLoading,
);

export const getEnumsSitePlatform = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsSitePlatform,
);

export const getEnumsSitePlatformLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsSitePlatformLoading,
);

export const getEnumsLegalStatusEu = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsLegalStatusEu,
);

export const getEnumsLegalStatusEuLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsLegalStatusEuLoading,
);

export const getEnumsManualFeeClass = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsManualFeeClass,
);

export const getEnumsManualFeeClassLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsManualFeeClassLoading,
);

export const getEnumsMonthlyFees = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsMonthlyFees,
);

export const getEnumsMonthlyFeesLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsMonthlyFeesLoading,
);

export const getEnumsServiceType = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsServiceType,
);

export const getEnumsServiceTypeLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsServiceTypeLoading,
);
// ==========================================:
// EM Comments

export const getEmComments = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emComments,
);

export const getEmCommentsData = createSelector(
	[getEmComments],
	(emComments: TEmCommentsResponsePayload) => emComments,
);

export const getEmCommentsLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emCommentsLoading,
);

// EM Notifications
export const getEmNotifications = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emNotifications,
);

export const getEmNotificationsData = createSelector(
	[getEmNotifications],
	(emNotifications: TEmCommentsResponsePayload) => emNotifications,
);

export const getEmNotificationsLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emNotificationsLoading,
);

export const getEmComment = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emComment,
);

export const getEmCommentData = createSelector(
	[getEmComment],
	(emComment: TEmCommentGetByIdResponsePayload) => emComment,
);

export const getEmCommentLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emCommentLoading,
);

export const getCreateEmCommentLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.createEmCommentLoading,
);

export const getCreateEmCommentSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.createEmCommentSuccess,
);

export const getUpdateEmCommentLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.updateEmCommentLoading,
);

export const getUpdateEmCommentSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.updateEmCommentSuccess,
);

// ==========================================:
// nominated person account

export const getRegisterNominatedPersonAccountLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.registerNominatedPersonAccountLoading,
);

export const getRegisterNominatedPersonAccountSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.registerNominatedPersonAccountSuccess,
);

// ==========================================:
// EM Sites

export const getEmSitesList = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emSitesList,
);

export const getEmSitesListData = createSelector(
	[getEmSitesList],
	(emSitesList: TEmSitesListResponsePayload) => emSitesList,
);

export const getEmSitesListLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emSitesListLoading,
);

export const getCreateEmSiteLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.createEmSiteLoading,
);

export const getCreateEmSiteSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.createEmSiteSuccess,
);

export const getUpdateEmSiteLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.updateEmSiteLoading,
);

export const getUpdateEmSiteSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.updateEmSiteSuccess,
);

export const getDeleteEmSiteLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.deleteEmSiteLoading,
);

export const getDeleteEmSiteSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.deleteEmSiteSuccess,
);

// ==========================================:
// Dashboard users subscriptions

export const getEmDashboardUsersSubscriptions = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emDashboardUsersSubscriptions,
);

export const getEmDashboardUsersSubscriptionsData = createSelector(
	[getEmDashboardUsersSubscriptions],
	(emDashboardUsersSubscriptions) =>
		emDashboardUsersSubscriptions
			? {
					firstName: '',
					lastName: '',
					...emDashboardUsersSubscriptions,
				}
			: null,
);

export const getEmDashboardUsersSubscriptionsLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emDashboardUsersSubscriptionsLoading,
);

export const getUpdateEmDashboardUsersSubscriptionsLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.updateEmDashboardUsersSubscriptionsLoading,
);

export const getUpdateEmDashboardUsersSubscriptionsSuccess = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.updateEmDashboardUsersSubscriptionsSuccess,
);

// ==========================================:
// EM Invoice List

export const getEmInvoiceList = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emInvoiceList,
);

export const getEmInvoiceListData = createSelector(
	[getEmInvoiceList],
	(emInvoiceList: TEmInvoiceListResponsePayload) => emInvoiceList,
);

export const getEmInvoiceListLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emInvoiceListLoading,
);

// ==========================================
// EM Payment Methods
// ==========================================

export const getEmPaymentMethods = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emPaymentMethods,
);

export const getEmPaymentMethodsData = createSelector(
	[getEmPaymentMethods],
	(emPaymentMethods: TEmPaymentMethodsResponsePayload) => emPaymentMethods,
);

export const getEmPaymentMethodsLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.emPaymentMethodsLoading,
);

// ==========================================
// Enum dictionary browser (Reference Tables / Enums)
// ==========================================

export const getDistinctEnumNames = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.distinctEnumNames,
);

export const getDistinctEnumNamesLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.distinctEnumNamesLoading,
);

export const getEnumsByName = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsByName,
);

export const getEnumsByNameLoading = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsByNameLoading,
);

export const getEnumsByNameError = createSelector(
	[getEmManagementState],
	(emManagement: TEmManagementStore) => emManagement.enumsByNameError,
);
